export function NewEliteEliteInsightsTilesSkeleton() {
  return (
    <div className='mt-2 w-full animate-pulse'>
      <div className='flex flex-col gap-7 bg-white px-3'>
        <div className='space-y-2'>
          <div className='h-3 w-36 rounded bg-[#E8E8E8]' />
          <div className='h-6 w-44 rounded bg-[#E8E8E8]' />
        </div>
        <div className='flex flex-col gap-4'>
          <div className='h-[72px] w-full rounded-xl bg-[#E8E8E8]' />
          <div className='h-[72px] w-full rounded-xl bg-[#E8E8E8]' />
          <div className='h-[72px] w-full rounded-xl bg-[#E8E8E8]' />
        </div>
      </div>
    </div>
  )
}
